import type { DashboardWidgetConfig } from "../types/core"
import { getWidgetMetricFilters } from "./widgetMetricFilterValidation"

export function getWidgetMetricReferenceIds(
  ...configs: Array<DashboardWidgetConfig | undefined>
): string[] {
  return [
    ...new Set(
      configs
        .flatMap((config) =>
          config
            ? [
                config.metricId,
                ...(config.metricIds ?? []),
                ...(config.filters?.metricIds ?? []),
                ...(getWidgetMetricFilters(config.metricFilter) ?? []).map(
                  (filter) => filter.metricId,
                ),
              ]
            : [],
        )
        .filter((id): id is string => Boolean(id)),
    ),
  ]
}
